module.exports = __webpack_public_path__ + "static/media/fast-food.276a75bc.png";